import { render } from "./clinic-create.vue?vue&type=template&id=1db23c74&scoped=true"
import script from "./clinic-create.vue?vue&type=script&lang=js"
export * from "./clinic-create.vue?vue&type=script&lang=js"

import "./clinic-create.vue?vue&type=style&index=0&id=1db23c74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db23c74"]])

export default __exports__